<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../../stores/auth'
import LoginForm from './LoginForm.vue'
import CompanySelectionDialog from './CompanySelectionDialog.vue'
import ForgotPasswordForm from './ForgotPasswordForm.vue'
import RegistrationWizard from './RegistrationWizard.vue'

const currentView = ref<'login' | 'forgot-password' | 'register'>('login')
const store = useAuthStore()
const { showCompanySelection } = storeToRefs(store)

defineEmits<{
  (e: 'close'): void
}>()

// Watch for company selection dialog to show
watch(showCompanySelection, (show) => {
  if (show) {
    // Close the auth modal when company selection shows
    //emit('close')
  }
})

const modalWidthClass = computed(() => {
  let cl = 'max-w-md'
  if (currentView.value === 'register') {
    cl =  'max-w-2xl'
  } else if (showCompanySelection.value) {
    cl =  'max-w-3xl'
  }
  return cl;
})
</script>

<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="relative w-full" :class="modalWidthClass">
      <!-- Auth forms -->
       <CompanySelectionDialog 
        v-if="showCompanySelection"
        @close="$emit('close')"
      />
      <template v-else>
      <LoginForm 
        v-if="currentView === 'login'"
        @forgot-password="currentView = 'forgot-password'"
        @register="currentView = 'register'"
        @close="$emit('close')"
      />      
      <ForgotPasswordForm
        v-else-if="currentView === 'forgot-password'"
        @back="currentView = 'login'"
      />
      <RegistrationWizard
        v-else
        @complete="currentView = 'login'"
        @signin="currentView = 'login'"
      />
      </template>
    </div>
  </div>
</template>